import { render } from "./CmsAddonsForModelsSection.vue?vue&type=template&id=317f8731&scoped=true"
import script from "./CmsAddonsForModelsSection.vue?vue&type=script&lang=js"
export * from "./CmsAddonsForModelsSection.vue?vue&type=script&lang=js"

import "./CmsAddonsForModelsSection.vue?vue&type=style&index=0&id=317f8731&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317f8731"]])

export default __exports__